<template>
    <section class="relative min-h-screen overflow-hidden bg-[#0f1115] text-white">
        <div class="absolute inset-0">
            <div class="absolute inset-0 bg-[#0f1115]"></div>
            <div class="glow glow-yellow"></div>
            <div class="glow glow-white"></div>
        </div>
        <div class="relative container flex min-h-screen items-center py-10 md:py-20">
            <div class="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
                <div class="lg:col-span-7">
                    <Breadcrumbs theme="dark"/>
                    <p class="mb-2 text-xs font-semibold uppercase tracking-[0.12em] text-white/50">
                        Страница находится в разработке
                    </p>

                    <h1 class="mb-6 text-2xl font-extrabold leading-[1.04] tracking-[-0.04em] md:text-4xl">
                        Скоро здесь появится новый раздел
                    </h1>

                    <p class="quote mb-6 max-w-2xl text-sm leading-[1.48] text-white/80 md:text-[18px] xl:text-[17px]">
                        Мы уже работаем над этой страницей. Скоро здесь будет
                        доступна подробная информация, структура услуги и все
                        необходимые материалы.
                    </p>

                    <div class="mt-10 flex flex-col gap-4 sm:flex-row">
                        <a
                            href="/"
                            class="inline-flex h-[52px] w-full items-center justify-center rounded-xl bg-baseColor px-6 text-[16px] font-bold text-black transition hover:bg-[#e6b000] md:w-auto md:min-w-[226px]"
                        >
                            На главную
                        </a>

                        <button
                            type="button"
                            @click="goBack"
                            class="inline-flex h-[52px] w-full items-center justify-center rounded-xl border border-white/10 bg-white/5 px-6 text-[16px] font-bold text-white transition hover:bg-white/10 md:w-auto md:min-w-[226px]"
                        >
                            Назад
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";

const goBack = () => {
    if (window.history.length > 1) {
        window.history.back();
        return;
    }

    window.location.href = "/";
};
</script>

<style scoped lang="scss">
.glow {
    position: absolute;
    width: 420px;
    height: 420px;
    border-radius: 9999px;
    filter: blur(120px);
    opacity: 0.25;
    pointer-events: none;
    animation: float 12s ease-in-out infinite;
}

.glow-yellow {
    background: #FFC400;
    top: -120px;
    left: -80px;
    animation-delay: 0s;
}

.glow-white {
    background: #ffffff;
    bottom: -120px;
    right: -80px;
    opacity: 0.12;
    animation-delay: 4s;
}

@keyframes float {
    0% {
        transform: translate(0, 0) scale(1);
    }
    50% {
        transform: translate(40px, 30px) scale(1.1);
    }
    100% {
        transform: translate(0, 0) scale(1);
    }
}
</style>
